import React, {useState} from "react";
import './index.css';
import Correct from '../../../image/correct.png';
import Wrong from '../../../image/wrong.png';

export default ({text, correct, fontSize}) => {
    const [type, setType] = useState('default');
    const [src, setSrc] = useState(Correct);
    const [signActive, setSignActive] = useState('none');

    const onClick = (v) => {
        setType(correct ? 'correct' : 'wrong');
        setSrc(correct ? Correct : Wrong);
        setSignActive('block');
    }

    return (
        <div className={`question-option ${type}`}>
            <span className="sign"/>
            <div className="box">
                <button style={{fontSize: fontSize}} onClick={onClick}>{text}</button>
            </div>
            <span className="sign">
                <img style={{display: signActive}} src={src} alt=""/>
            </span>
        </div>
    )
}